var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14037 0.57025C6.38028 0.361373 6.68711 0.25 7 0.25C7.31289 0.25 7.61972 0.361373 7.85963 0.57025L7.86994 0.579227L13.3199 5.50196C13.4517 5.61805 13.5592 5.76074 13.634 5.92237C13.7101 6.08677 13.75 6.26603 13.75 6.44832V12.4783C13.75 12.8266 13.605 13.1535 13.3587 13.3892C13.1134 13.6237 12.7877 13.75 12.4546 13.75H9.18135C8.84827 13.75 8.52249 13.6237 8.27725 13.3892C8.03088 13.1535 7.88593 12.8266 7.88593 12.4783V9.57617H6.11339V12.4783C6.11339 12.8266 5.96843 13.1535 5.72206 13.3892C5.47683 13.6237 5.15105 13.75 4.81797 13.75H1.54542C1.21234 13.75 0.886561 13.6237 0.641324 13.3892C0.394956 13.1535 0.25 12.8266 0.25 12.4783V6.4484C0.250019 6.2661 0.289925 6.08677 0.365986 5.92237C0.440761 5.76075 0.548327 5.61806 0.680076 5.50198L6.14037 0.57025ZM7 1.81493L1.75 6.55688V12.25H4.61339V9.3479C4.61339 8.9996 4.75834 8.67268 5.00471 8.43701C5.24995 8.20243 5.57573 8.07617 5.90881 8.07617H8.09051C8.42359 8.07617 8.74937 8.20243 8.99461 8.43701C9.24098 8.67268 9.38593 8.9996 9.38593 9.3479V12.25H12.25V6.55688L7 1.81493ZM1.67366 6.62569C1.67266 6.6266 1.67165 6.6275 1.67064 6.62838L1.67366 6.62569Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/House.7b166c3c757e5e945f7083919cef5292.svg";
export { ForwardRef as ReactComponent };